<div class="form-component">
    <h4>
        Map Columns for Performance Data Import
    </h4>

    <div *ngIf="validationMessage" class="validation-warning" style="background-color: #fff3cd; padding: 12px; margin-bottom: 16px; border-left: 4px solid #ffc107; border-radius: 4px;">
        <strong>⚠ Warning:</strong> {{ validationMessage }}
    </div>

    <form #form="ngForm">
        <div *ngFor="let mapping of columnMappings; let i = index" class="column-mapping-row">

            <div class="input-group">
                <label>
                    {{ mapping['columnIndex'] }}: {{ mapping['sourceColumnDescription'] }}
                </label>
                <div class="input-group-column">
                    <select [(ngModel)]="columnMappings[i]['destinationColumn']" [ngModelOptions]="{ standalone: true }" (change)="onMappingChange()">
                        <option value="">Select field</option>
                        <option *ngFor="let option of databaseColumns" [value]="option.name">
                            {{ option.description }}{{ option.required ? ' *' : '' }}
                        </option>
                    </select>

                    <a href="#" (click)="toggleAdvanced(mapping, $event)" class="toggle-advanced">
                        {{ mapping.showAdvanced ? 'Hide' : 'Show' }} advanced options
                    </a>
                </div>
            </div>

            <div *ngIf="mapping.showAdvanced" class="advanced-options">
                <div class="input-group">
                    <label for="formatString-{{ i }}">Format String</label>
                    <input id="formatString-{{ i }}" type="text" [(ngModel)]="columnMappings[i]['formatString']" [ngModelOptions]="{ standalone: true }" />
                </div>

                <div class="input-group">
                    <label for="regex-{{ i }}">Regex</label>
                    <input id="regex-{{ i }}" type="text" [(ngModel)]="columnMappings[i]['regex']" [ngModelOptions]="{ standalone: true }" />
                </div>
            </div>
        </div>
    </form>
</div>